import CustomKeyboard from './CustomKeyboard';

export default CustomKeyboard;
